import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { whatsappUrl } from '../../data/links';
import { trackPixelEvent } from '../../utils/metaPixel';

/** Botón fijo de WhatsApp, siempre visible en celular. */
export function StickyCta() {
  return <div className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#08090b]/95 p-3 backdrop-blur lg:hidden" data-id="element-109" data-mp="1nnz1f0jj2k9k">
      <a href={whatsappUrl('Hola VCARS, quiero asesoramiento para comprar un auto.')} target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('Contact', {
      content_name: 'Botón fijo WhatsApp'
    })} className="flex w-full items-center justify-center gap-2 rounded-full bg-[#3b6bff] px-6 py-3.5 text-base font-semibold text-white transition-colors duration-150 ease-out hover:bg-[#2b57e0]" data-id="element-110" data-mp="1epeqwmo4fgwf">
        <MessageCircleIcon className="h-5 w-5" strokeWidth={2.2} data-id="element-111" data-mp="2z61mk9mrdbm5" />
        Escribinos por WhatsApp
      </a>
    </div>;
}